import { z } from 'zod';

export const userSchema = z.object({
  email: z.email(),
  display_name: z.string().nullable(),
  status: z.enum(['active', 'suspended', 'deactivated']),
  email_verified: z.boolean().nullish(),
});

export const serviceAccessSchema = z.object({
  slug: z.string(),
  name: z.string(),
  url: z.string(),
  access_token: z.string().nullish(),
});

export const sessionSchema = z.object({
  access_token: z.string(),
  refresh_token: z.string(),
  expires_in: z.number(),
  user: userSchema.nullish(),
  services: z.array(serviceAccessSchema).nullish(),
});

export type Session = z.infer<typeof sessionSchema>;
export type ServiceAccess = z.infer<typeof serviceAccessSchema>;
export type User = z.infer<typeof userSchema>;
